/// <amd-module name="Wit/Portal/Redux/ConfigureWorkItemPortalStore" />
import { createStore, IModuleStore } from "redux-dynamic-modules";
import { getSagaExtension } from "redux-dynamic-modules-saga";
import { getWorkItemPortalModule } from "./WorkItemPortalModule";
import { IVssPageContext } from "VSS/Platform/Context";
import { defaultWorkItemPortalState, IWorkItemPortalAwareState } from "./WorkItemPortalContracts";

export function configureWorkItemPortalStore(pageContext: IVssPageContext): IModuleStore<IWorkItemPortalAwareState> {
    return createStore<IWorkItemPortalAwareState>(
        {
            initialState: {
                workItemPortalState: defaultWorkItemPortalState
            },
            enhancers: [],
            extensions: [getSagaExtension({ pageContext })]
        },
        ...getWorkItemPortalModule()
    );
}
